import i18n from "i18next";
import * as Yup from "yup";

import { settings } from "@krea/customer-features/settings";
import { minFinancingAmountPerCountry } from "@krea/customer-features/utils";

export const UnpaidInvoicesBaseValidation = () => {
  return Yup.object().shape({
    estimatedInvoiceAmount: Yup.number()
      .required(
        `${i18n.t(
          "applicationForm.commons.unpaidInvoicesValidation.unpaidInvoicesEstimatedRequired",
        )}`,
      )
      .moreThan(
        minFinancingAmountPerCountry[settings.countryCode].numericValue - 1,
        `${i18n.t("applicationForm.common.minimumFinancingAmountValidation", {
          amount:
            minFinancingAmountPerCountry[settings.countryCode].stringValue,
        })}`,
      )
      .typeError(
        `${i18n.t(
          "applicationForm.commons.unpaidInvoicesValidation.unpaidInvoicesEstimatedInvalid",
        )}`,
      ),

    numberOfInvoices: Yup.number()
      .typeError(
        `${i18n.t(
          "applicationForm.commons.unpaidInvoicesValidation.numberOfUnpaidInvoicesInvalid",
        )}`,
      )
      .required(
        `${i18n.t(
          "applicationForm.commons.unpaidInvoicesValidation.numberOfUnpaidInvoicesRequired",
        )}`,
      ),
    averagePaymentTimeDays: Yup.number(),
  });
};

export const UnpaidInvoicesDescriptionValidation = () => {
  return Yup.string().required(
    `${i18n.t(
      "applicationForm.commons.unpaidInvoicesValidation.descriptionUnpaidInvoicesRequired",
    )}`,
  );
};
